export default __webpack_public_path__ + "static/media/obcianske.d62522ad.jpg";